<style lang="scss">
  .component__character-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50vh;
    background-color: orangered;
    display: inline-block;
    color: white;
    line-height: 36px;
    text-align: center;
  }
</style>
<template>
  <div class="component__character-avatar"
       :style="`background-color:${color}; width: ${size}; height: ${size}; line-height: ${size};`">
    {{char}}
  </div>
</template>
<script>
  import {color_stack} from '../global'

  export default {
    name: 'component__av-char',
    props: {
      // full_name: {
      //   type: String,
      //   default: ''
      // },
      size: {
        type: String,
        default: '36px'
      }
    },
    data () {
      return {
        color_list: ['#FF00FF', '#FF80FF', '#FF0080', '#8000FF', '#400080', '#8080C0', '#800040', '#800080', '#400040', '#0080FF', '#0080C0', '#8080FF', '#0000A0', '#000040', '#00FFFF', '#004080', '#0000FF', '#408080', '#00FF80', '#00FF00', '#008000', '#008040', '#FFFF80', '#FF8040', '#804000', '#808000', '#FF8080', '#FF0000', '#804040', '#800000', '#146B21'],
        color: 'red',
        char: 'A',
        full_name: ''
      }
    },
    beforeMount () {
      this.full_name = this.$store.state.userInfo.display_name

      let color_stack_name = color_stack.map(e => e.text)
      if (color_stack_name.includes(this.full_name)) {
        this.color = color_stack[color_stack_name.indexOf(this.full_name)].color
      } else {
        this.color = this.color_list[this.random_range(0, this.color_list.length - 1)]
        color_stack.push({
          text: this.full_name,
          color: this.color
        })
      }
      let char_index = 0
      for (let i = 0; i < this.full_name.length; i++) {
        if (this.full_name[i] === ' ' && this.full_name[i + 1] !== ' ' && isNaN(Math.floor(this.full_name[i + 1]))) char_index = i + 1
      }
      // this.char = this.full_name[char_index].toUpperCase()
      this.char = this.full_name[char_index].toUpperCase()
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/av_character.vue